/** 13 communes officielles de la région de Conakry (MATD, 2026). */
export const CONAKRY_COMMUNES = [
  { key: 'kaloum', label: 'Kaloum', lat: 9.5095, lng: -13.7122 },
  { key: 'dixinn', label: 'Dixinn', lat: 9.5378, lng: -13.6775 },
  { key: 'matam', label: 'Matam', lat: 9.5505, lng: -13.668 },
  { key: 'matoto', label: 'Matoto', lat: 9.5776, lng: -13.6684 },
  { key: 'ratoma', label: 'Ratoma', lat: 9.63, lng: -13.622 },
  { key: 'gbessia', label: 'Gbéssia', lat: 9.5769, lng: -13.6119 },
  { key: 'tombolia', label: 'Tombolia', lat: 9.655, lng: -13.548 },
  { key: 'sonfonia', label: 'Sonfonia', lat: 9.618, lng: -13.578 },
  { key: 'lambanyi', label: 'Lambanyi', lat: 9.642, lng: -13.568 },
  { key: 'kagbelen', label: 'Kagbélén', lat: 9.705, lng: -13.508 },
  { key: 'sanoyah', label: 'Sanoyah', lat: 9.548, lng: -13.518 },
  { key: 'maneah', label: 'Manéah', lat: 9.735, lng: -13.47 },
  { key: 'kassa', label: 'Kassa', lat: 9.475, lng: -13.805 }
];

/** Communes / préfectures de la grande couronne (hors Conakry). */
export const NEAR_CONAKRY_COMMUNES = [
  { key: 'dubreka', label: 'Dubréka', lat: 9.791, lng: -13.523 },
  { key: 'coyah', label: 'Coyah', lat: 9.706, lng: -13.385 },
  { key: 'maferinyah', label: 'Maférinyah', lat: 9.546, lng: -13.28 },
  { key: 'forecariah', label: 'Forécariah', lat: 9.431, lng: -13.088 }
];

/** 8 régions administratives de Guinée. */
export const GUINEA_REGIONS = [
  { key: 'region-conakry', label: 'Conakry', lat: 9.5095, lng: -13.7122 },
  { key: 'region-kindia', label: 'Kindia', lat: 10.057, lng: -12.866 },
  { key: 'region-boke', label: 'Boké', lat: 10.941, lng: -14.296 },
  { key: 'region-mamou', label: 'Mamou', lat: 10.375, lng: -12.091 },
  { key: 'region-labe', label: 'Labé', lat: 11.318, lng: -12.283 },
  { key: 'region-faranah', label: 'Faranah', lat: 10.04, lng: -10.743 },
  { key: 'region-kankan', label: 'Kankan', lat: 10.385, lng: -9.306 },
  { key: 'region-nzerekore', label: 'Nzérékoré', lat: 7.756, lng: -8.818 }
];

const CONAKRY_COMMUNE_KEYS = new Set(CONAKRY_COMMUNES.map((item) => item.key));
const KINDIA_AREA_KEYS = new Set(NEAR_CONAKRY_COMMUNES.map((item) => item.key));

const ALL_LOCATIONS = [...CONAKRY_COMMUNES, ...NEAR_CONAKRY_COMMUNES, ...GUINEA_REGIONS];

export function getGuineaLocationByKey(key) {
  return ALL_LOCATIONS.find((item) => item.key === key) || null;
}

export function getGuineaLocationLabel(key) {
  return getGuineaLocationByKey(key)?.label || String(key || '').trim();
}

export function getGuineaLocationCoords(key) {
  const loc = getGuineaLocationByKey(key);
  const lat = Number(loc?.lat);
  const lng = Number(loc?.lng);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  return { lat, lng };
}

export function getGuineaLocationType(key) {
  if (!key) return '';
  return String(key).startsWith('region-') ? 'region' : 'commune';
}

export function getBusinessLocationLabel(business) {
  if (!business) return '';
  const stored = String(business.locationLabel || '').trim();
  if (stored) return stored;
  return getGuineaLocationLabel(business.quartier);
}

/** `region-conakry` : communes de Conakry. `region-kindia` : grande couronne (Dubréka, Coyah, Maférinyah, Forécariah). */
export function businessMatchesLocation(business, locationKey) {
  if (!locationKey) return true;
  const key = String(business?.quartier || '').trim();
  if (key === locationKey) return true;
  if (locationKey === 'region-conakry') {
    return CONAKRY_COMMUNE_KEYS.has(key);
  }
  if (locationKey === 'region-kindia') {
    return KINDIA_AREA_KEYS.has(key);
  }
  const label = getBusinessLocationLabel(business);
  const wanted = getGuineaLocationLabel(locationKey);
  return Boolean(wanted) && normalizeLoose(label) === normalizeLoose(wanted);
}

function normalizeLoose(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}
